export default "__VITE_ASSET__DEVo8dX6__"